import { useCommunityDictionary } from '@/shared/api';
import {
  Card,
  Loader,
  ModalComponentWrapper,
  UserProfileAction,
} from '@/shared/components';
import { useTranslation } from 'react-i18next';
import TwitterLogo from '@/shared/assets/twitter-logo.svg?react';
import TelegramLogo from '@/shared/assets/telegram-logo.svg?react';
import InstagramLogo from '@/shared/assets/instagram-logo.svg?react';
import FacebookLogo from '@/shared/assets/facebook-logo.svg?react';
import YoutubeLogo from '@/shared/assets/youtube-logo.svg?react';
import LinkedinLogo from '@/shared/assets/linkedin-logo.svg?react';
import VkLogo from '@/shared/assets/vk-logo.svg?react';
import type { CommunityPlatform } from '@/shared/types';

type Props = {
  onBack: () => void;
};

type LogoMap = Record<
  CommunityPlatform,
  React.FC<React.SVGProps<SVGSVGElement>>
>;

export function CommunityModal({ onBack }: Props) {
  const { t } = useTranslation();

  const { communityData, isCommunityLoading, communityError } =
    useCommunityDictionary();

  if (isCommunityLoading || !communityData) {
    return <Loader />;
  }

  if (communityError) {
    return <div>Error</div>;
  }

  const getLogo = (platform: CommunityPlatform) => {
    const logos: LogoMap = {
      Twitter: TwitterLogo,
      Telegram: TelegramLogo,
      Instagram: InstagramLogo,
      Facebook: FacebookLogo,
      YouTube: YoutubeLogo,
      Linkedin: LinkedinLogo,
      VK: VkLogo,
    };

    return logos[platform] ?? null;
  };

  return (
    <ModalComponentWrapper
      title={t('personalAccount.userProfile.community.title')}
      onBack={onBack}
      headerClassName="text-secondary-bg bg-secondary-bg/50">
      <Card className="p-[0.8rem] rounded-[1.6rem] w-full shadow-none flex flex-col gap-2">
        {communityData.value.links.map((linkObj, index) => {
          const [platform, url] = Object.entries(linkObj)[0];

          const Logo = getLogo(platform as CommunityPlatform);

          return (
            <UserProfileAction
              key={`${platform}-${index}`}
              showChevron={false}
              icon={Logo && <Logo className="size-10 text-primary" />}
              title={platform}
              onClick={() => window.open(url, '_blank')}
            />
          );
        })}
      </Card>
    </ModalComponentWrapper>
  );
}
